import type { RequestOptions } from 'owa-service/lib/RequestOptions';
import getGroupRoutedRequestInit from 'owa-group-common/lib/utils/getGroupRoutedRequestInit';
import { fullResponseOperationOption } from '../../../../shared';

export function getGroupOwsOptions(routingHint: string, prefixedId?: string): RequestOptions {
    return {
        ...getGroupRoutedRequestInit(routingHint, prefixedId),
        ...fullResponseOperationOption,
    };
}
